// extracted by mini-css-extract-plugin
export default {"advertCardList":"c-a_hs","advertCardList_max6":"c-a_ht"};